import React, { useEffect } from "react";
import { Checkbox, Flex, Form, Input, Modal, notification, Select, Space, Typography } from "antd";
import { routes } from './../../../views/index'
import { useAntIcons } from "../../../hooks/useIcons";
import { useDispatch } from "react-redux";
import { putData } from "../../../actions/developer";
const { useForm } = Form;

interface ItemRecord {
    status?: string;
    _id?: string;
    name: string;
    parentMenu?: string;
    createdAt?: string;
    updatedAt?: string;
    subparentMenu?: string;
    routeUrl?: string;
    componentName?: string;
    icon?: string;
    order: number;
    subMenu?: string;
    mainMenuRef?: any;
    subMenuRef?: any;
    parentMenuRef?: any;
    newTab?: any;
    list?: ItemRecord[];
}

interface RouteEditProps {
    id?: string;
    open: boolean;
    onClose: () => void;
    editItem: ItemRecord;
}
const RouteEdit: React.FC<RouteEditProps> = ({
    open,
    editItem,
    onClose
}) => {
    const [form] = useForm();
    const dispatch = useDispatch();

    const getNameValue = (item) => {
        if (item?.parentMenu) return item?.parentMenu;
        if (item?.subMenu) return item?.subMenu;
        return item?.name;
    }

    useEffect(() => {
        console.log(editItem)
        if (editItem) {
            const getName = (item) => getNameValue(item).replace(/ /g, '-').toLowerCase();
            let routeUrl = editItem.routeUrl;
            if (!editItem.routeUrl) {
                let tempArray = []
                if (editItem.mainMenuRef) {
                    tempArray.push(getName(editItem.mainMenuRef))
                }
                if (editItem.subMenuRef) {
                    tempArray.push(getName(editItem.subMenuRef))
                }
                if (editItem.name) {
                    tempArray.push(getName(editItem))
                }
                routeUrl = tempArray.join('/')
            }

            form.setFieldsValue({
                name: editItem.name,
                componentName: editItem.componentName,
                routeUrl: routeUrl
            })
        }
    }, [editItem])


    const updateRecords = async (_id, values) => {
        try {
            const resData = await dispatch(putData(`/routing/tab/list/${_id}`, values));
            if (resData) {
                onClose();
            } else {
                notification.error({ message: 'Error', description: resData.message });
            }
        } catch (error) {
            notification.error({ message: 'Error', description: error.message });
        }
    }

    return (
        <Modal
            title="Edit Route Config"
            open={open}
            onOk={() => form.submit()}
            onCancel={() => onClose()}
        >
            <Form
                form={form}
                onFinish={(e) => { updateRecords(editItem._id, e) }}
                layout="vertical"
            >
                <Space direction="vertical" style={{ width: '100%' }}>
                    <Flex justify="space-between" gap={16} style={{ width: '100%' }}>
                        <Form.Item
                            label="Component Name"
                            name="componentName"
                            style={{ width: '100%' }}
                            rules={[{ required: true, message: 'Please enter component name' }]}
                        >
                            <Select allowClear showSearch>
                                {Object.keys(routes).map(ele => <Select.Option value={ele}>{ele}</Select.Option>)}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="Route Name"
                            name="name"
                            style={{ width: '100%' }}
                            rules={[{ required: true, message: 'Please enter route name' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Flex>
                    <Form.Item
                        label="Route URL"
                        name="routeUrl"
                        rules={[{ required: true, message: 'Please enter route url' }]}
                    >
                        <Input addonBefore={process.env.CRM_URL + '/'} />
                    </Form.Item>
                    <Form.Item
                        name="dontListInMenu"
                    >
                        <Checkbox>Don't list in Menu</Checkbox>
                    </Form.Item>
                </Space>
            </Form>
        </Modal>
    );
}

export default RouteEdit;